import React from "react";
import "./style.css";
import HeroImage from "../HeroImage/HeroImage";
import { GeoAlt, Telephone } from "react-bootstrap-icons";

const MainAbout = () => {
  return (
    <div
      className="all-main-about
     container px-0 my-3"
    >
      <HeroImage />
      <div className="   main-about py-4 d-flex justify-content-between  align-items-center align-content-sm-stretch flex-column flex-sm-column flex-md-row ">
        <div className="text-about w-50 ps-5 ">
          <p className=" inner-aboute  text-justify ">
            طرح <strong className="text-dark">رفاه داپ‌اَپ</strong> از یک پلتفرم
            پاداش نقدی خرید (کَش بَک) استفاده می‌کند. به این ترتیب ۴ تا ۵۴ درصد
            از مبلغ هر خرید از <strong className="text-dark">فروشگاه</strong>{" "}
            های عضو دا‌پ‌اَپ به شما برمی‌گردد. با برگشت پول از هر خرید قدرت خرید
            شما افزایش پیدا می‌کند و کسب و کارها رونق می‌گیرند.
          </p>
          <p className=" text-justify">
            در صورت بروز هر گونه مشکل در فرایند برگشت پول یا نحوه عملکرد{" "}
            <strong className="text-dark">اپلیکیشن</strong> با تکمیل و ارسال فرم
            زیر، کارشناسان پشتیبانی ما در سریع‌ترین زمان ممکن با شما تماس
            می‌گیرند.
          </p>
          <h6>دفتر مرکزی داپ اپ :</h6>
          <p className="inner-aboute  text-justify">
            <GeoAlt size={25} className="ms-2 mb-1" />
            آدرس: <br /> تهران، خیابان ولیعصر، بالاتر از تقاطع فاطمی، کوچه شهید
            حمیدرضا افتخاری نیا، پلاک ۵۲
          </p>
          <p className="inner-aboute  text-justify">
            <Telephone size={23} className="ms-2 mb-1" />
            تلفن پشتیبانی:
            <br />
            <span className="ps-2 pt-2">۰۲۱-۸۸۸۹۳۲۱۷</span> |
            <span className="ps-2 mt-5">۰۹۰۱-۳۵۶۸۶۵۷</span>
          </p>
        </div>
        <div className=" daap-map w-50 m-0 ">
          {/* location daap app */}
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d481.5104929133464!2d51.409761462486635!3d35.72121148168498!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3f8e01e1a9b6e8bb%3A0x2ce7b4fc0c99020b!2sDaap!5e0!3m2!1sen!2s!4v1642934524313!5m2!1sen!2s"
            width="100%"
            height="350"
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default MainAbout;
